export default __webpack_public_path__ + "static/media/ic_edit.59037b81.svg";